import { render, staticRenderFns } from "./DeletionActivationsModal.vue?vue&type=template&id=01de95e3&scoped=true"
import script from "./DeletionActivationsModal.vue?vue&type=script&lang=js"
export * from "./DeletionActivationsModal.vue?vue&type=script&lang=js"
import style0 from "./DeletionActivationsModal.vue?vue&type=style&index=0&id=01de95e3&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01de95e3",
  null
  
)

export default component.exports